import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getContracts, getContract, deleteContract } from "../../api/webServices";
import { deleteContractAction, setActualContract, setContractMode, setContractsList } from "../../store/reducers/contractsSlice";
import ItemsTable from "../ItemsTable";
import { CiSearch } from 'react-icons/ci';
import './Contracts.css';
import { getPermissions } from "../../utils/various";


const Contracts = () => {

    const { contractsList } = useSelector(state => state.contracts);
    const [filteredContracts, setfilteredContracts] = useState([]);
    const { sessionData } = useSelector(state => state.session);
    const permissions = getPermissions(sessionData?.role);
    const ref = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        // Cargar requests
        getContracts().then(res => dispatch(setContractsList(res?.data)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddContract = async () => {
        dispatch(setContractMode('new'));
        navigate('/contract');
    }

    const handleEditContract = async (id) => {
        getContract(id).then(res => {
            dispatch(setContractMode('update'));
            dispatch(setActualContract(res?.data));
            navigate('/contract');
        }).catch(err => {
            console.log(err);
        });
    }

    const handleViewContract = async (id) => {
        getContract(id).then(res => {
            dispatch(setContractMode('view'));
            dispatch(setActualContract(res?.data));
            navigate('/contract');
        }).catch(err => {
            console.log(err);
        });
    }

    const handleFilterContract = () => {
        let id = ref.current.value;
        if (id === "") {
            setfilteredContracts([]);
        } else {
            let filtered = contractsList.filter(contract => contract.id === parseInt(id));
            setfilteredContracts(filtered);
        }
    }

    const handleDeleteContract = (id) => {
        deleteContract({ id }).then(res => {
            dispatch(deleteContractAction(id));
        }).catch(err => {
            console.log(err);
        }
        );
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] bg-white h-[90%] my-auto rounded-2xl">
                <h2 className="2xl:py-8 2xl:leading-[75px] text-[30px] 2xl:text-[40px] mt-7 titleRequests">Contratos</h2>
                <div className="2xl:w-[65%] w-[80%] mx-auto mt-10">
                    <div className="flex flex-row items-center gap-3">
                        <button className="mx-5 newRequestButton" onClick={handleAddContract}>+ Crear contrato</button>
                        <div className="searchRequestContainer">
                            <p>Ingrese ID:</p>
                            <input ref={ref} type="text" className="searchRequestInput">
                            </input>
                            <button className="searchRequestButton" onClick={handleFilterContract}><CiSearch size={24} /></button>
                        </div>
                    </div>
                    <ItemsTable
                        permissions={permissions}
                        type="contracts"
                        data={filteredContracts?.length > 0 ? filteredContracts : contractsList}
                        handleEdit={handleEditContract}
                        handleView={handleViewContract}
                        handleDelete={handleDeleteContract}
                    />
                </div>
            </div>
        </div>
    )
}

export default Contracts;